(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('office365AtpLinksLogic', ["simpleSortableLogicCore", "fileDao", "widgetPolling", "defaultListConverter", "$q", function (simpleSortableLogicCore, fileDao, widgetPolling, defaultListConverter, $q) {
        return function ($scope, logic) {
            if (_($scope.model.wrapper.showLoading).isUndefined()) {
                $scope.model.wrapper.showLoading = true;
            }
            $scope.model.wrapper.isLoading = true;
            var id = logic.entityId || widgetPolling.scope().id;
            var entityType = logic.entityType || widgetPolling.scope().entityType;
            return simpleSortableLogicCore($scope, logic, {
                retrieve: function () {
                    return fileDao.office365AtpLinks(id, entityType).converter(function (input) {
                        var deferred = $q.defer();
                        deferred.resolve($.extend({}, input, { data: { rows: input.data.rows } }));
                        $scope.model.wrapper.isLoading = false;
                        return deferred.promise;
                    }).converter(defaultListConverter, { columns: $scope.model.columns });
                }
            });
        };
    }]);
}());